import React, { Component } from 'react';
import moment from 'moment';

import LocationForwardSettingForm from './LocationForwardSettingForm';

import { defaultSorter, dateSorter } from './Helpers';
import LocationForwardlocationsModel from './LocationForwardlocationsModel';
import UserModel from './UserModel';

import { Table, Badge, Divider, Row, Col, Statistic, Popconfirm, Typography, message, Card, Tooltip } from 'antd';

class LocationForwardlocationsTable extends Component {

    state = {
        children: [],
        filteredInfo: {},
        sortedInfo: {},
        parkingconnFormData: null,
        parkingconnPasswordFormData: null
    }

    handleChange = (pagination, filters, sorter) => {
        this.setState({
            filteredInfo: filters,
            sortedInfo: sorter,
        });
    }

    expandedRowRender(record) {
        return (
            <div>
                <Row style={{ marginBottom: 20 }}>
                    <Col span={24}>
                        <Card title="Popis">
                            {record.description ? record.description : " - "}
                        </Card>
                    </Col>
                    <Col span={7}>
                        <Card title="Událost">
                            {record.eventListener ? record.eventListener : " - "}
                        </Card>
                    </Col>

                    <Col span={10}>
                        <Card title="Poslední data">
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                {record.lastData ? JSON.stringify(record.lastData, null, 2) : " - "}
                            </pre>
                        </Card>
                    </Col>
                </Row>
                <Row>
                    <Col span={10}>
                        <Card title="forwardConfig">
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                {record.forwardConfig ? JSON.stringify(record.forwardConfig, null, 2) : "-"}
                            </pre>
                        </Card>
                    </Col>
                    <Col span={10}>
                        <Card title="forwardData">
                            <pre style={{ margin: 0, whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
                                {record.forwardData ? JSON.stringify(record.forwardData, null, 2) : "-"}
                            </pre>
                        </Card>
                    </Col>
                </Row>
            </div >
        );
    }

    render() {

        let { sortedInfo, filteredInfo } = this.state;

        const columns = [{
            title: 'Lohalita',
            dataIndex: 'parkingLocationName',
            key: 'parkingLocationName',
            width: 250,
            sorter: (a, b) => defaultSorter(a.parkingLocationName, b.parkingLocationName),
        }, {
            title: 'Poslední MQTT',
            dataIndex: 'lastMqttStamp',
            key: 'lastMqttStamp',
            width: 180,
            sorter: (a, b) => dateSorter(a.lastMqttStamp, b.lastMqttStamp),
            render: (text, record) => {
                return record.lastMqttStamp ? moment(text).format('L LTS') : '-'
            }
        }, {
            title: 'Poslední forward',
            dataIndex: 'lastSendStamp',
            key: 'lastSendStamp',
            width: 180,
            sorter: (a, b) => dateSorter(a.lastSendStamp, b.lastSendStamp),
            render: (text, record) => {
                return record.lastSendStamp ? moment(text).format('L LTS') : '-'
            }

        }, {
            title: 'Čas odeslání',
            dataIndex: 'scheduledForwardTime',
            key: 'scheduledForwardTime',
            width: 120,
            render: (text, record) => record.scheduledForwardTime || '-'
        }, {
            title: 'Aktivní',
            dataIndex: 'active',
            key: 'active',
            width: 70,
            align: 'center',
            filters: [{
                text: 'ANO',
                value: true,
            }, {
                text: 'NE',
                value: false,
            }],
            filteredValue: filteredInfo.active || null,
            onFilter: (value, record) => { return ((record.active === value)) ? true : false },
            render: (text, record) => {
                if (record.active === true) {
                    return (
                        <Badge
                            status="success"
                        />
                    );
                } else {
                    return (
                        <Badge
                            status="error"
                        />
                    );
                }
            }
        }, {
            title: 'Akce',
            key: 'Action',
            width: 250,
            render: (text, record) => {
                if (UserModel.isInRoles(['ADMIN', 'LOCATION_FORWARD_WRITE'])) {
                    return (
                        <div>
                            <a onClick={(e) => {
                                this.setState({
                                    parkingconnFormData: record
                                });
                            }}>Nastavení</a>
                            <Divider type="vertical" />
                            <Popconfirm placement="right" title="Opravdu si přejete záznam smazat?" onConfirm={() => {
                                this.props.onRemoveRow
                                    ? this.props.onRemoveRow(record.id)
                                    : null;
                            }} okText="Ano" cancelText="Ne">
                                <a onClick={(e) => { e.preventDefault(); }}><Typography.Text type="danger">Smazat</Typography.Text></a>
                            </Popconfirm>
                        </div>
                    );
                }
            }
        }]

        return (
            <div>
                <Table
                    size='small'
                    rowKey={this.props.rowKey ? this.props.rowKey : 'id'}
                    loading={this.props.loading ? this.props.loading : false}
                    columns={columns}
                    dataSource={this.props.data}
                    style={{ border: '0px' }}
                    pagination={{
                        showSizeChanger: true,
                        defaultPageSize: localStorage.getItem('table_pageSize') !== undefined
                            ? parseInt(localStorage.getItem('table_pageSize'))
                            : 10,
                        onShowSizeChange: (current, size) => {
                            localStorage.setItem('table_pageSize', size);
                        }
                    }}
                    onChange={this.handleChange}
                    expandedRowRender={this.expandedRowRender.bind(this)}
                    rowSelection={
                        this.props.rowSelection !== undefined
                            ? this.props.rowSelection
                            : null
                    }
                />
                <LocationForwardSettingForm
                    type="modal"
                    modalVisible={this.state.parkingconnFormData === null ? false : true}
                    initialValues={this.state.parkingconnFormData}
                    onModalCancel={(form) => {
                        form.resetFields();
                        this.setState({ parkingconnFormData: null });
                    }}
                    onSuccess={(form, values) => {
                        LocationForwardlocationsModel.patch(this.state.parkingconnFormData.id, values)
                            .then(() => {
                                message.success("Změna byla uložena!");
                                form.resetFields();
                                this.setState({
                                    parkingconnFormData: null
                                });
                                if (this.props.onAnyFormSuccess) {
                                    this.props.onAnyFormSuccess();
                                }
                            })
                            .catch(err => {
                                message.warning('Změnu se nepodařilo uložit. Zkontrolujte spravnou funkčnost služby.');
                            })
                    }} />
            </div>
        );
    }
}

export default LocationForwardlocationsTable;


// WEBPACK FOOTER //
// ./src/components/LocationForwardlocationsTable.js